import React from "react";
import Header from "../../components/admin/Header";
import Sidebar from "../../components/admin/Sidebar";
import { Outlet } from "react-router";

const AdminLayout = () => {
  return (
    <div className="w-screen h-screen flex bg-[#edf7fd]">
      <div className="hidden lg:block">
        <Sidebar />
      </div>
      <div className="overflow-y-auto scrollbar-hide w-full h-full">
        <div className="sticky top-0 z-50">
          <Header />
        </div>
        <div className="p-3 lg:p-10">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
